var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader",class:{ 'loader--dark' : _vm.darkMode }},[_c('span',{staticClass:"loader__ball",class:{ 'loader__ball--dark' : _vm.darkMode }})])
}
var staticRenderFns = []

export { render, staticRenderFns }